import { Badge, BadgeProps } from "@minuthq/meatball-ui-react"

import { TUserOrderDetails } from "src/data/billing/types/billingTypes"
import { useTranslate } from "src/i18n/useTranslate"
import { ErrorService } from "src/utils/ErrorService"

type TUserOrderStatus = TUserOrderDetails["status"]

export function UserOrderStatusBadge({
  status,
  size = "medium",
}: {
  status: TUserOrderStatus
  size?: BadgeProps["size"]
}) {
  const { t, langKeys } = useTranslate()

  function getStatusLabel(status: TUserOrderStatus) {
    switch (status) {
      case "shipped": {
        return t(langKeys.orders_status_shipped)
      }
      case "delivered": {
        return t(langKeys.orders_status_delivered)
      }
      case "cancelled": {
        return t(langKeys.orders_status_cancelled)
      }
      case "new": {
        return t(langKeys.orders_status_new)
      }
      case "awaiting_shipment": {
        return t(langKeys.orders_status_awaiting_shipment)
      }
      case "returned": {
        return t(langKeys.orders_status_returned)
      }
      default: {
        ErrorService.captureMessage(`Unknown order status: ${status}`)
        return status
      }
    }
  }

  return (
    <Badge size={size} color={getStatusColor(status)}>
      {getStatusLabel(status)}
    </Badge>
  )
}

function getStatusColor(status: TUserOrderStatus): BadgeProps["color"] {
  switch (status) {
    case "shipped":
    case "delivered":
      return "good"
    case "cancelled":
      return "error"
    default:
      return "warning"
  }
}
